/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreErrorKey {
  static readonly UNDEFINED_ERROR = 'kit-core/error/undefined-error';
  static readonly UNHANDLED_ERROR = 'kit-core/error/unhandled-error';
  static readonly HTTP_ERROR = 'kit-core/error/http-error';
  static readonly NETWORK_ERROR = 'kit-core/error/network-error';

  static readonly INVALID_STATE = 'kit-core/error/invalid-state';

  static readonly NOT_IMPLEMENTED = 'kit-core/error/not-implemented';
  static readonly NOT_FOUND = 'kit-core/error/not-found';
  static readonly NOT_SUPPORTED = 'kit-core/error/not-supported';

  static readonly LOCALE_NOT_FOUND = 'kit-core/error/locale-not-found';
  static readonly LOCALE_RESOLVE_ERROR = 'kit-core/error/locale-resolve-error';

  static readonly TEXT_KEY_INVALID = 'kit-core/error/text-key-invalid';
  static readonly TEXT_KEY_INCOMPLETE = 'kit-core/error/text-key-incomplete';
  static readonly TEXT_PATTERNS_MISSING = 'kit-core/error/text-patterns-missing';
  static readonly TEXT_PATTERNS_INVALID = 'kit-core/error/text-patterns-invalid';

  static readonly RESOURCE_KEY_INVALID = 'kit-core/error/resource-key-invalid';
  static readonly RESOURCE_KEY_INCOMPLETE = 'kit-core/error/resource-key-incomplete';
  static readonly RESOURCE_MISSING = 'kit-core/error/resource-missing';
  static readonly RESOURCE_INVALID = 'kit-core/error/resource-invalid';

  static readonly KEY_MISSING = 'kit-core/error/key-missing';
  static readonly KEY_INVALID = 'kit-core/error/key-invalid';

  static readonly ARGUMENT_MISSING = 'kit-core/error/argument-missing';
  static readonly ARGUMENT_INVALID = 'kit-core/error/argument-invalid';

  static readonly AUTHENTICATION_MISSING = 'kit-core/error/authentication-missing';
  static readonly AUTHENTICATION_INVALID = 'kit-core/error/authentication-invalid';
  static readonly AUTHENTICATION_EXPIRED = 'kit-core/error/authentication-expired';

  static readonly SOURCE_MISSING = 'kit-core/error/source-missing';
  static readonly SOURCE_INVALID = 'kit-core/error/source-invalid';

  static readonly OPTIONS_INVALID = 'kit-core/error/options-invalid';
  static readonly OPTION_INVALID = 'kit-core/error/option-invalid';

  static readonly COMPARE_MODE_INVALID = 'kit-core/error/compare-mode-invalid';
  static readonly OBSERVE_MODE_INVALID = 'kit-core/error/observe-mode-invalid';

  static readonly CIRCULAR_REFERENCE = 'kit-core/error/circular-reference';

  static readonly FORMATTER_NOT_FOUND = 'kit-core/error/formatter-not-found';
  static readonly FORMATTER_OPTIONS_INVALID = 'kit-core/error/formatter-options-invalid';
  static readonly FORMAT_ERROR = 'kit-core/error/format-error';
  static readonly PARSE_ERROR = 'kit-core/error/parse-error';

  static readonly VALIDATION_ERROR = 'kit-core/error/validation-error';
  static readonly VALIDATION_RULES_MISSING = 'kit-core/error/validation-rules-missing';
  static readonly VALIDATION_RULES_INVALID = 'kit-core/error/validation-rules-invalid';
  static readonly VALIDATION_KEY_MISSING = 'kit-core/error/validation-key-missing';
  static readonly VALIDATION_KEY_INVALID = 'kit-core/error/validation-key-invalid';
  static readonly VALIDATION_KEY_EVALUATION = 'kit-core/error/validation-key-evaluation';
  static readonly VALIDATION_OPTIONS_MISSING = 'kit-core/error/validation-options-missing';
  static readonly VALIDATION_OPTIONS_INVALID = 'kit-core/error/validation-options-invalid';
  static readonly VALIDATION_CONTEXT_MISSING = 'kit-core/error/validation-context-missing';
  static readonly VALIDATION_CONTEXT_INVALID = 'kit-core/error/validation-context-invalid';
  static readonly FIELD_VALIDATION_ERROR = 'kit-core/error/field-validation-error';
  static readonly OBJECT_VALIDATION_ERROR = 'kit-core/error/object-validation-error';

  static readonly TASK_INVOCATION_ERROR = 'kit-core/error/task-invoation-error';

  static readonly CSV_SOURCE_INVALID = 'kit-core/error/csv-source-invalid';

  static readonly CUSTOM_TEXT_ERROR = 'kit-core/error/custom-text-error';
}
